import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { showSSOButtons } from "@faire/retailer-visitor-shared/lib/ssoUtils";
import { getDocument } from "@faire/web--source/common/globals/getDocument";
import { loadScript } from "@faire/web--source/common/loadScript";
var GOOGLE_LOGIN_SCRIPT_NAME = "_googleLogin";
var GOOGLE_LOGIN_SCRIPT_SRC = "https://accounts.google.com/gsi/client";
export var isGoogleLoginSciptLoaded = function() {
    var _getDocument;
    return !!((_getDocument = getDocument()) === null || _getDocument === void 0 ? void 0 : _getDocument.getElementById(GOOGLE_LOGIN_SCRIPT_NAME));
};
export var loadGoogleLoginScript = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(!isGoogleLoginSciptLoaded() && showSSOButtons())) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        loadScript(GOOGLE_LOGIN_SCRIPT_SRC, GOOGLE_LOGIN_SCRIPT_NAME)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return function loadGoogleLoginScript() {
        return _ref.apply(this, arguments);
    };
}();
